<template lang="pug">
.central-eventos(v-loading='carregando')
        h3 {{ $t('mensagens.home.centralEventos.titulo') }}
    
        .lyra__cartao(v-if='eventos.length')
            .central-eventos__evento(v-for='evento in eventos')
                .evento__data
                    h2 {{ evento.dia }}
                    h3 {{ internacionalizarMeses(evento.mes) }}
                .evento__texto
                    p {{ internacionalizarMensagens(evento.mensagem) }}
    
        .lyra__cartao(v-else)
            .central-eventos__vazio
                h4 {{ $t('mensagens.home.centralEventos.nenhumEventoRecente') }}
</template>
    
<script>
    import CentralEventosService from '@/services/CentralEventosService';
    import { mapState } from 'vuex';
    
    export default {
        name: 'CentralEventos',
    
        data() {
            return {
                eventos: [],
                carregando: true
            };
        },

        computed: {
            ...mapState(['usuarioLogado'])
        },

        watch: {
            usuarioLogado: {
                handler() {
                    this.buscarEventos();
                },
                deep: true
            }
        },
    
        mounted() {
            this.buscarEventos();
        },
    
        methods: {
            async buscarEventos() {
                this.carregando = true;
                try {
                    const { data } = await CentralEventosService.buscarEventos();
                    this.eventos = data;
                } catch {
                    this.$notify.error({
                        message: this.$t('mensagens.home.centralEventos.erro')
                    });
                } finally {
                    this.carregando = false;
                }
            },
            internacionalizarMensagens(texto) {
                const [chaveOriginal, ...restoTexto] = texto.split(':');
                const valorTexto = restoTexto.join(':').trim();
                
                const chaveNormalizada = this.formatadorDeTexto(chaveOriginal);
                
                const chaveTraduzida = this.$t(`mensagens.home.centralEventos.mensagens.${chaveNormalizada}`);
    
                return `${chaveTraduzida}: ${valorTexto}`;
            },
            internacionalizarMeses(texto) {
                const chaveNormalizada = this.formatadorDeTexto(texto);
                
                const chaveTraduzida = this.$t(`mensagens.home.centralEventos.meses.${chaveNormalizada}`);
    
                return chaveTraduzida;
            },
            formatadorDeTexto(texto) {
                return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();
            }
        }
    };
</script>
    
    <style lang="scss" scoped>
    .lyra__cartao {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        padding: 20px;
        overflow: auto;
    }
    
    .central-eventos {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    
        & > h3 {
            font-weight: 700;
            margin-bottom: 5px;
        }
    }
    
    .central-eventos__evento {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 6px 7px;
        gap: 13px;
        border-radius: 5px;
        cursor: default;
    
        .evento__data {
            min-width: 40px;
            border-radius: 5px;
            text-align: center;
            padding: 5px;
            color: var(--white);
        }
    
        .evento__texto {
            display: flex;
            align-items: center;
            color: var(--primary);
    
            p {
                margin: 0;
            }
        }
    }
    
    .central-eventos__evento {
        background: var(--color-button-default-hover);
    
        .evento__data {
            background: var(--secondary);
        }
    }
    
    .central-eventos__vazio {
        height: 100%;
        text-align: center;
        display: grid;
        place-items: center;
    }
</style>
